import * as Yup from "yup";

export const contactvalidation = Yup.object({
  fname: Yup.string()
    .label("First Name")
    .min(2)
    .max(19)
    .required("Please Enter Your First Name"),
  lname: Yup.string()
    .label("Last Name")
    .min(2)
    .max(19)
    .required("Please Enter Your Last Name"),
  emailID: Yup.string()
    .label("Email")
    .email()
    .required("Please Enter Your Email"),
  mobile_no: Yup.number()
    .label("Mobile Number")
    .min(1000000000, "Mobile number must be at least 10 digits")
    .max(9999999999, "Mobile number cannot be more than 10 digits")
    .required("Please Enter Your Mobile Number"),
  message: Yup.string().required("Please Enter Your message"),
});
